import { Component, OnInit, HostListener } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { OrdersService } from '../orders.service'
import { SettingsService } from '../../settings/settings.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { PointsService } from 'src/app/plugins/points/components/points.service'
import { IntegrationsService } from 'src/app/integrations/integrations.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { LoginService } from 'src/app/login/login.service'
import { PushNotificationsService } from 'src/app/addons/push-notifications/push-notifications.service'
import { StorageService } from '../storage-service/storage.service'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { CountriesService } from 'src/app/builder-services/countries/countries.service'
import { environment } from 'src/environments/environment'
import { ShippingService } from '../../shipping/shipping.service'
import { ToastrService } from 'ngx-toastr'
import { getFincartPriceForGovernorate } from '../../shipping/fincart-pricing.constant'
import { MatDialog } from '@angular/material/dialog'
import { WorksDialogComponent } from 'src/app/pages/works-dialog/works-dialog.component'
import { ActiveShippingService } from '../../shipping-providers/shared/active-shipping.service'

@Component({
  selector: 'app-single-order',
  templateUrl: './single-order.component.html',
  styleUrls: ['./single-order.component.scss']
})
export class SingleOrderComponent implements OnInit {
  public orderIdFromRoute: any = []
  mobile = false
  orderData: any
  editAddress = false
  possibleStatuses = ['Order Received', 'Confirmed', 'Processing', 'Picked up', 'Completed', 'Cancelled', 'Refunded', 'On hold', 'Pending', 'Closed']
  selectedStatus = ''
  allowUpdateStatus = false
  addressForm!: FormGroup
  orderStatusForm!: FormGroup
  selectedAddress: any
  addressId!: any
  shippingCountries: any
  possibleGovernates: any
  shippingPrice: any
  customAddress: any
  isPhoneLogin: boolean = false
  // 'Size',,'Total Price'
  orderItems = ['image', 'product_name', 'price', 'sale_price', 'size', 'quantity', 'qr_data', 'total_price']
  countryDialCodes: any[] = []
  fullPhoneNumber: string = ''
  addressTypes = ['Home', 'Work']
  isExpanded = false
  readonly COLLAPSED_COUNT = 5
  pointsEarned: number = 0
  pointsRedeemed: number = 0
  userPointsBalance: number = 0

  // Meta Ads campaign/adset attribution — for chat-closed (e.g. Instagram DM) orders
  // the Meta Pixel/Insights API never sees, so campaign analysis would miss them.
  // Campaign/adset names are not unique per project (active + paused + deleted
  // campaigns can share a name), so status is shown alongside the name everywhere.
  metaCampaigns: { id: string; name: string; status: string }[] = []
  metaAdSets: { id: string; name: string; status: string }[] = []
  selectedMetaCampaignId: string | null = null
  selectedMetaCampaignName: string = ''
  selectedMetaCampaignStatus: string = ''
  selectedMetaAdSetId: string | null = null
  selectedMetaAdSetName: string = ''
  selectedMetaAdSetStatus: string = ''
  showMetaCampaignDropdown = false
  showMetaAdSetDropdown = false
  metaCampaignSearch = ''
  metaAdSetSearch = ''
  filteredMetaCampaigns: { id: string; name: string; status: string }[] = []
  filteredMetaAdSets: { id: string; name: string; status: string }[] = []
  savingMetaAttribution = false

  get reversedStatuses(): { orderStatus: string; stateChangeTime: string }[] {
    return this.orderService.orderStatuses.slice().reverse()
  }

  get visibleStatuses(): { orderStatus: string; stateChangeTime: string }[] {
    const all = this.reversedStatuses
    return this.isExpanded ? all : all.slice(0, this.COLLAPSED_COUNT)
  }

  trackByStatus(_index: number, entry: { orderStatus: string; stateChangeTime: string }): string {
    return `${entry.orderStatus}-${entry.stateChangeTime}`
  }
  productPhotos: { path: string; url: string }[] = []
  loading = false
  allowedPhotos: boolean = false
  fincartBaseUrl: string = environment.fincartBaseUrl
  fincartPickupLocationId: string = '681b4aaab280e5aa55446916'
  fincartOrder: any
  showStatusDropdown: boolean = false
  statusSearch: string = ''
  filteredStatuses: string[] = []
  fincartOrderCode: string = ''
  fincartOrderId: string = ''
  trackingUrl: string = ''
  shippingProviderEnabled: boolean = false
  shipmentTrackingNumber: string = ''
  shipmentLabelUrl: string = ''
  shipmentLoading: boolean = false

  get fincartActivated(): boolean {
    return this.builderService.fincartActive
  }

  get fincartApiKey(): string {
    return this.builderService.fincartApiKey
  }

  constructor(
    private route: ActivatedRoute,
    public orderService: OrdersService,
    public settingsService: SettingsService,
    public builderService: BuilderService,
    private pointsService: PointsService,
    private formBuilder: FormBuilder,
    public loginService: LoginService,
    public CountriesService: CountriesService,
    private pnService: PushNotificationsService,
    private storageService: StorageService,
    private http: HttpClient,
    private shippingService: ShippingService,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private integrationsService: IntegrationsService,
    private activeShippingService: ActiveShippingService
  ) {}

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap
    this.orderIdFromRoute = routeParams.get('orderId')
    this.builderService.headerBtn = 'orders/single-order'
    this.settingsService.getSettings().subscribe((response: any) => {
      this.allowedPhotos = response.allowUpload
      this.selectedStatus = response.content_settings?.initial_order_status || 'Order Received'
      if (response.fincartApiKey) {
        this.builderService.fincartApiKey = response.fincartApiKey
        this.builderService.fincartActive = true
      }
    })
    if (this.orderIdFromRoute) {
      this.getOrderData(this.orderIdFromRoute)
    }

    this.countryDialCodes = this.CountriesService.getCountries()

    this.addressForm = this.formBuilder.group({
      billing_postcode: [''],
      billing_country: [''],
      billing_state: [''],
      billing_street_Name: [''],
      billing_street_No: [''],
      billing_address_1: [''],
      billing_address_2: [''],
      type: [''],
      order_notes: [''],
      order_id: [''],
      shipping_price: [''],
      first_name: ['', Validators.compose([Validators.maxLength(30)])],
      last_name: ['', Validators.compose([Validators.maxLength(30)])],
      billing_phone: [''],
      phone_number: [''],
      country_code: [''],
      area: [''],
      billing_address_type: ['']
    })

    this.orderStatusForm = this.formBuilder.group({
      status: ['']
    })
    if (window.screen.width <= 768) {
      // 768px portrait
      this.mobile = true
    }

    this.getShippingData()
    this.loadProductPhotos()
    this.filteredStatuses = [...this.possibleStatuses]
    this.loadShippingProviderStatus()
    this.loadMetaCampaigns()
  }

  /**
   * Loads the active shipping provider status for the project and sets the gate flag.
   * The Ship Now button is shown only when a provider is connected and enabled.
   */
  private async loadShippingProviderStatus(): Promise<void> {
    const projectId = this.builderService.selectedProject
    if (!projectId) return
    await this.activeShippingService.loadActiveProvider(String(projectId))
    this.shippingProviderEnabled = !!this.activeShippingService.getActiveProvider()
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement
    if (!target.closest('.filter-dropdown')) {
      this.showStatusDropdown = false
      this.showMetaCampaignDropdown = false
      this.showMetaAdSetDropdown = false
    }
  }

  /** Loads the project's Meta Ads campaigns for the attribution picker. Called once on init. */
  private loadMetaCampaigns(): void {
    this.orderService.listMetaAdsCampaigns().subscribe({
      next: (campaigns) => {
        this.metaCampaigns = campaigns || []
        this.filteredMetaCampaigns = [...this.metaCampaigns]
        this.resolveExistingMetaCampaignName()
      },
      error: (err) => console.warn('[SingleOrderComponent] loadMetaCampaigns:', err)
    })
  }

  /**
   * Pre-fills the attribution picker from the order's stored meta_campaign_id/
   * meta_ad_set_id, if it was already tagged. Order data and the campaign list
   * load independently (ngOnInit fires both), so this is called from both paths
   * and only resolves the display name once the campaign list is actually in.
   */
  private applyExistingMetaAttribution(): void {
    const campaignId = this.orderData?.order?.metaCampaignId || null
    const adSetId = this.orderData?.order?.metaAdSetId || null
    if (!campaignId || !adSetId) return

    this.selectedMetaCampaignId = campaignId
    this.selectedMetaAdSetId = adSetId
    this.resolveExistingMetaCampaignName()

    this.orderService.listMetaAdsAdSets(campaignId).subscribe({
      next: (adSets) => {
        this.metaAdSets = adSets || []
        this.filteredMetaAdSets = [...this.metaAdSets]
        const match = this.metaAdSets.find((a) => a.id === adSetId)
        this.selectedMetaAdSetName = match?.name || ''
        this.selectedMetaAdSetStatus = match?.status || ''
      },
      error: (err) => console.warn('[SingleOrderComponent] applyExistingMetaAttribution adSets:', err)
    })
  }

  private resolveExistingMetaCampaignName(): void {
    if (!this.selectedMetaCampaignId) return
    const match = this.metaCampaigns.find((c) => c.id === this.selectedMetaCampaignId)
    if (match) {
      this.selectedMetaCampaignName = match.name
      this.selectedMetaCampaignStatus = match.status
    }
  }

  toggleMetaCampaignDropdown(event: Event) {
    event.stopPropagation()
    this.showMetaCampaignDropdown = !this.showMetaCampaignDropdown
    if (this.showMetaCampaignDropdown) {
      this.metaCampaignSearch = ''
      this.filteredMetaCampaigns = [...this.metaCampaigns]
    }
  }

  filterMetaCampaigns() {
    const search = this.metaCampaignSearch.toLowerCase()
    this.filteredMetaCampaigns = this.metaCampaigns.filter((c) => c.name.toLowerCase().includes(search))
  }

  selectMetaCampaign(campaign: { id: string; name: string; status: string }) {
    this.selectedMetaCampaignId = campaign.id
    this.selectedMetaCampaignName = campaign.name
    this.selectedMetaCampaignStatus = campaign.status
    this.selectedMetaAdSetId = null
    this.selectedMetaAdSetName = ''
    this.selectedMetaAdSetStatus = ''
    this.metaAdSets = []
    this.filteredMetaAdSets = []
    this.showMetaCampaignDropdown = false

    this.orderService.listMetaAdsAdSets(campaign.id).subscribe({
      next: (adSets) => {
        this.metaAdSets = adSets || []
        this.filteredMetaAdSets = [...this.metaAdSets]
      },
      error: (err) => console.warn('[SingleOrderComponent] listMetaAdsAdSets:', err)
    })
  }

  toggleMetaAdSetDropdown(event: Event) {
    event.stopPropagation()
    if (!this.selectedMetaCampaignId) return
    this.showMetaAdSetDropdown = !this.showMetaAdSetDropdown
    if (this.showMetaAdSetDropdown) {
      this.metaAdSetSearch = ''
      this.filteredMetaAdSets = [...this.metaAdSets]
    }
  }

  filterMetaAdSets() {
    const search = this.metaAdSetSearch.toLowerCase()
    this.filteredMetaAdSets = this.metaAdSets.filter((a) => a.name.toLowerCase().includes(search))
  }

  selectMetaAdSet(adSet: { id: string; name: string; status: string }) {
    this.selectedMetaAdSetId = adSet.id
    this.selectedMetaAdSetName = adSet.name
    this.selectedMetaAdSetStatus = adSet.status
    this.showMetaAdSetDropdown = false
  }

  saveMetaAttribution() {
    if (!this.selectedMetaCampaignId || !this.selectedMetaAdSetId) return
    this.savingMetaAttribution = true
    this.orderService.setMetaAdsAttribution(this.orderIdFromRoute, this.selectedMetaCampaignId, this.selectedMetaAdSetId).subscribe({
      next: () => {
        this.savingMetaAttribution = false
        this.toastrService.success('Order attributed to campaign')
      },
      error: (err) => {
        this.savingMetaAttribution = false
        console.warn('[SingleOrderComponent] saveMetaAttribution:', err)
        this.toastrService.error('Failed to attribute order to campaign')
      }
    })
  }

  toggleStatusDropdown(event: Event) {
    event.stopPropagation()
    this.showStatusDropdown = !this.showStatusDropdown
    if (this.showStatusDropdown) {
      this.statusSearch = ''
      this.filteredStatuses = [...this.possibleStatuses]
    }
  }

  filterStatuses() {
    const search = this.statusSearch.toLowerCase()
    this.filteredStatuses = this.possibleStatuses.filter((status) => status.toLowerCase().includes(search))
  }

  selectStatus(status: string) {
    this.selectedStatus = status
    this.showStatusDropdown = false
    this.allowUpdateStatus = true
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded
  }

  /**
   * Fetches the order data for the specified order ID and populates the properties.
   * If the order has an address ID, it calls the `fetchAddress` method to retrieve the address data.
   * If the order does not have an address ID, it retrieves the address data from the user's data and assigns it to the properties.
   * @param orderId - The ID of the order to fetch data for.
   */
  getOrderData(orderId: any) {
    this.orderService.getOrder(orderId).subscribe((orderData: any) => {
      if (!orderData || !orderData[0]) {
        console.warn('Order not found:', orderId)
        return
      }
      this.orderService.orderData = orderData
      this.orderData = orderData[0]
      // Normalize order data to handle different order types (app, menu, pos, website)
      // Must be called before accessing fincartOrderId to ensure items are converted to products
      this.normalizeOrderData()

      this.loadPointsData()

      this.fincartOrderCode = this.orderData.order.fincartOrderId?.fincartCode || ''
      this.fincartOrderId = this.orderData.order.fincartOrderId?.fincartId || ''
      this.trackingUrl = this.orderData.order.fincartOrderId?.trackingUrl || ''

      this.shipmentTrackingNumber = this.orderData.order.aymakanData?.trackingNumber || ''
      this.shipmentLabelUrl = this.orderData.order.aymakanData?.labelUrl || ''

      this.applyExistingMetaAttribution()

      this.selectedStatus = this.orderData.order.status
      //Checks if user logged in using phone number
      if (this.orderData.user_id && this.orderData.user_id.substring(0, 3) === 'sms') {
        this.isPhoneLogin = true
      }

      this.orderStatusForm.patchValue({
        status: this.selectedStatus
      })
      const humId = String(this.orderData.order.humId)

      this.orderData.order.products = this.orderData.order.products.map((product: any) => {
        const qrMatch = (product.qrCode || []).find((qr: any) => String(qr.orderId || qr.order_id) === humId)

        return {
          ...product,
          qr_data: qrMatch ? qrMatch.value : '__'
        }
      })
      // checks if orderstatuses exist in db if not initialize with the order's initial status
      if (this.orderData.order.orderStatuses) {
        this.orderService.orderStatuses = this.orderData.order.orderStatuses
      } else {
        this.orderService.orderStatuses = [{
          orderStatus: this.orderData.order.status || 'Order Received',
          stateChangeTime: this.orderData.order.date
        }]
      }
      if (this.orderData.order.address_id != null) {
        this.fetchAddress(orderData[0])
      } else {
        this.addressId = this.orderData?.user_data?.address && Object.keys(this.orderData?.user_data?.address)[0]
        let foundAddress = false

        // Try to get address from orderData.address array
        if (Array.isArray(this.orderData.address) && this.orderData.address.length > 0) {
          this.selectedAddress = this.orderData.address[0]
          this.customAddress = this.orderData.address[0].type === 'customAddress' ? this.orderData.address[0] : ''
          foundAddress = true
        } else {
          // Try to get from address object (legacy format)
          for (const key in this.orderData.address) {
            if (Object.prototype.hasOwnProperty.call(this.orderData.address, key)) {
              const element = this.orderData.address[key]
              this.orderData.address = element
              this.selectedAddress = element
              this.customAddress = element.type === 'customAddress' ? element : ''
              foundAddress = true
            }
          }
        }

        // Fallback: construct from order data if no address found
        if (!foundAddress) {
          this.selectedAddress = this.constructAddressFromOrderData(this.orderData)
        }
      }

      // Sync Fincart order status if fincartOrderId exists
      if (this.orderData.order.fincartOrderId) {
        this.getFincartOrderLogs(this.orderData.order.fincartOrderId)
      }
    })
  }

  private async loadPointsData(): Promise<void> {
    const orderId = this.orderIdFromRoute
    const userId = this.orderData?.user_id
    const projectId = this.builderService.selectedProject

    if (!orderId || !userId || !projectId) return

    const ledgerRows = await this.pointsService.getOrderPointsLedger(orderId)

    if (ledgerRows) {
      this.pointsEarned = ledgerRows
        .filter((row: any) => row.source_type === 'earn_order')
        .reduce((sum: number, row: any) => sum + (row.points || 0), 0)

      this.pointsRedeemed = Math.abs(
        ledgerRows
          .filter((row: any) => row.source_type === 'redeem')
          .reduce((sum: number, row: any) => sum + (row.points || 0), 0)
      )
    }

    this.userPointsBalance = await this.pointsService.getUserPointsBalance(userId)
  }

  /**
   * Normalizes order data to a unified structure that works for all order types (app, menu, pos, website)
   * This ensures the template can display orders from any source consistently
   */
  private normalizeOrderData() {
    const order = this.orderData.order
    const orderType = order.type || this.orderData.source || 'app'

    // Normalize humId (order display ID)
    if (!order.humId && order.id) {
      order.humId = order.id
    }

    // Normalize products array - convert items to products if needed
    if (!order.products && order.items) {
      order.products = order.items.map((item: any) => {
      const normalizedProduct = this.normalizeProductItem(item)

      // ✅ Preserve selectedVariation from DB items
      if (item.selectedVariation !== undefined) {
        normalizedProduct.selectedVariation = item.selectedVariation
      }

      return normalizedProduct
    })
      } else if (order.products) {
      order.products = order.products.map((product: any) =>
      this.normalizeProductItem(product)
    )
  }

    // Normalize financial fields
    if (order.shippingPrice === undefined) {
      order.shippingPrice = 0
    }

    // Fix: Recalculate total from products to ensure consistency for OLD orders
    // New orders are fixed at source, but this handles existing data
    if (order.products && order.products.length > 0) {
      order.subTotal = order.products.reduce((sum: number, product: any) => {
        const price = Number(product.salePrice) || Number(product.regularPrice) || 0
        const quantity = Number(product.quantity) || 1
        return sum + (price * quantity)
      }, 0)
    } else {
       // Fallback for orders without products array or legacy structure
      if (order.subTotal === undefined && order.subtotal !== undefined) {
        order.subTotal = order.subtotal
      }
      if (order.subTotal === undefined && order.total !== undefined) {
        order.subTotal = order.total
      }
    }

    // Recalculate total: subTotal + shipping - coupon discount - points discount
    const couponDiscount = Number(order.discount) || Number(order.couponsDiscount) || 0
    const pointsDiscount = Number(order.pointsDiscount) || 0
    const subtotal = Number(order.subtotal) || Number(order.subTotal) || 0
    order.subtotalAfterDiscounts = subtotal - couponDiscount - pointsDiscount
    order.total = order.subtotalAfterDiscounts + (Number(order.shippingPrice) || 0)

    // Normalize payment method
    if (!order.payment_method) {
      if (order.cardAmount > 0 && order.cashAmount > 0) {
        order.payment_method = 'Split Payment'
      } else if (order.cardAmount > 0) {
        order.payment_method = 'Card'
      } else {
        order.payment_method = 'Cash'
      }
    }

    // Normalize user data for website orders
    if (orderType === 'website' && !this.orderData.user_data?.given_name) {
      if (order.guestName) {
        const nameParts = order.guestName.split(' ')
        this.orderData.user_data = {
          ...this.orderData.user_data,
          given_name: nameParts[0] || '',
          family_name: nameParts.slice(1).join(' ') || '',
          email: order.guestEmail || '',
          uid: this.orderData.user_id || order.userId || ''
        }
      }
    }
    // Normalize user data for pos/menu orders with guest userId (numeric like "1", "50", etc.)
    const userId = this.orderData.user_data?.uid
    const isGuestUser = (orderType === 'pos' || orderType === 'menu') && (userId == null || !this.orderData.user_data?.given_name)
    if (isGuestUser) {
      this.orderData.user_data = {
        uid: userId || 'guest',
        given_name: 'Guest',
        family_name: 'Customer',
        email: ''
      }
    }

    // Normalize address for website orders
    if (orderType === 'website' && order.deliveryAddress) {
      this.selectedAddress = {
        billing_address_1: order.deliveryAddress,
        billing_country: order.deliveryCountry || '',
        billing_state: order.deliveryCity || '',
        first_name: order.guestName?.split(' ')[0] || '',
        last_name: order.guestName?.split(' ').slice(1).join(' ') || '',
        phone_number: order.guestPhone || ''
      }
    }
  }


  /**
   * Normalizes a single product/item to the unified product structure expected by the template
   * @param item The raw product or item from any order type
   * @returns Normalized product object
   */
  private normalizeProductItem(item: any): any {
    // Handle imageUrl - can be string, array, or img field
    let imageUrl = item.imageUrl || item.img || ''
    if (Array.isArray(imageUrl)) {
      imageUrl = imageUrl[0] || ''
    }

    // Calculate item_finalPrice
    const regularPrice = item.regularPrice || 0
    const salePrice = item.salePrice || 0
    const itemFinalPrice = item.item_finalPrice || (salePrice > 0 ? salePrice : regularPrice)

    return {
      ...item,
      imageUrl: imageUrl,
      productName: item.productName || item.name || '',
      regularPrice: regularPrice,
      salePrice: salePrice,
      item_finalPrice: itemFinalPrice,
      quantity: item.quantity || 1,
      product_id: item.product_id || item.productId || ''
    }
  }

  async loadProductPhotos() {
    this.orderService.getOrder(this.orderIdFromRoute).subscribe(async (resp) => {
      if (resp?.[0]?.user_id && this.orderData?.order?.products?.length > 0) {
        const productId = this.orderData.order.products[0].product_id
        const userId = this.orderData.user_id
        this.loading = true
        try {
          // Get photo URLs for this specific product
          const photos = await this.storageService.getProductPhotos(this.builderService.selectedProject, userId, productId)

          this.productPhotos = photos
        } catch (error) {
          console.error('Error getting product photos:', error)
        } finally {
          this.loading = false
        }
      }
    })
  }
  /**
   * Returns a readable label for a selected variation of a variable product.
   *
   * This method matches the selected variation value (e.g. "small")
   * with its corresponding product attribute (e.g. "size") and
   * formats it as "size: small".
   *
   * If the product is not variable, has no selected variation,
   * or no matching attribute is found, an empty string or the
   * raw selected value is returned.
   *
   * @param product - Product object from the order
   * @returns A formatted variation label (e.g. "Size: small") or an empty string
   */
  getSelectedVariationLabel(product: any): string {
  const selectedVariation = product?.selectedVariation;

  // ❌ No variation data
  if (!selectedVariation) {
    return '';
  }

  // ✅ Support BOTH shapes:
  // 1) selectedVariation.values
  // 2) selectedVariation === { values: "small,white", ... }
  const rawValues =
    typeof selectedVariation === 'string'
      ? selectedVariation
      : selectedVariation?.values;

  if (!rawValues) {
    return '';
  }

  // Split values: "small,white" → ["small", "white"]
  const selectedValues = rawValues
    .split(',')
    .map((v: string) => v.trim())
    .filter(Boolean);

  if (!selectedValues.length) {
    return '';
  }

  const labels: string[] = [];

  // If productAttributes exist, map values to attribute names
  if (Array.isArray(product?.productAttributes)) {
    for (const value of selectedValues) {
      const attribute = product.productAttributes.find((attr: any) =>
        attr.value
          ?.split(',')
          .map((v: string) => v.trim())
          .includes(value)
      );

      if (attribute) {
        labels.push(`${attribute.name}: ${value}`);
      } else {
        labels.push(value); // fallback
      }
    }
  } else {
    // No attributes → just show values
    labels.push(...selectedValues);
  }

  return labels.join(', ');
}
  downloadImage(imageUrl: string, index: number): void {
    // Use fetch to get the image as blob
    fetch(imageUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.blob()
      })
      .then((blob) => {
        // Create blob URL
        const blobUrl = URL.createObjectURL(blob)

        // Create download link
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = `product-photo-${index + 1}.jpg`
        link.style.display = 'none'

        // Add to DOM and trigger download
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // Clean up blob URL
        URL.revokeObjectURL(blobUrl)
      })
      .catch((error) => {
        console.error('Download failed:', error)

        // Fallback: try the canvas method
        this.downloadImageViaCanvas(imageUrl, index)
      })
  }

  private downloadImageViaCanvas(imageUrl: string, index: number): void {
    const img = new Image()
    img.crossOrigin = 'anonymous'

    img.onload = () => {
      try {
        // Create canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        if (!ctx) {
          throw new Error('Could not get canvas context')
        }

        canvas.width = img.width
        canvas.height = img.height

        // Draw image on canvas
        ctx.drawImage(img, 0, 0)

        // Convert canvas to blob and download
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const blobUrl = URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = blobUrl
              link.download = `product-photo-${index + 1}.jpg`
              link.style.display = 'none'

              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)

              URL.revokeObjectURL(blobUrl)
            } else {
              console.error('Failed to create blob from canvas')
              alert('Failed to download image. Please try again.')
            }
          },
          'image/jpeg',
          0.9
        )
      } catch (error) {
        console.error('Canvas method failed:', error)
        alert('Failed to download image. Please try again.')
      }
    }

    img.onerror = () => {
      console.error('Failed to load image for canvas download')
      alert('Failed to download image. Please try again.')
    }

    img.src = imageUrl
  }

  getFileName(filePath: string): string {
    return filePath.split('/').pop() || 'Unknown'
  }

  onImageLoad(index: number): void {
    console.log(`Image ${index + 1} loaded successfully`)
  }

  onImageError(index: number): void {
    console.error(`Failed to load image ${index + 1}`)
  }

  /**
   * Updates the status of an order and handles the corresponding points actions.
   * @param allowUpdateStatus - A boolean indicating whether the order status can be updated.
   * @param event - The event object containing the new order status.
   */
  updateStatus(allowUpdateStatus: boolean, event: any) {
    this.selectedStatus = event.value
    this.allowUpdateStatus = allowUpdateStatus
  }

  /**
   * Updates the status of the current order and handles corresponding points actions.
   *
   * - Checks if the selected status is different from the current one.
   * - If different, updates the status in the database and saves the status change history.
   * - Sends a push notification based on the new status.
   * - If the status is 'Completed', adds reward points to the user.
   * - Otherwise, removes any previously added points.
   *
   * @returns void
   */

  saveUpdateStatus() {
    if (this.selectedStatus === this.orderData.order.status) {
      alert('Status is the same. No update performed.')
      this.allowUpdateStatus = false
      return
    }
    const previousStatus = this.orderData.order.status
    this.orderService.updateOrderStatus(this.orderIdFromRoute, this.selectedStatus, this.orderData.user_id, this.orderData.source).subscribe((response: any) => {
      this.orderData.order.status = this.selectedStatus
      this.allowUpdateStatus = false
      this.pnService.automate(this.selectedStatus, this.orderData.user_id)

      if (this.selectedStatus === 'Completed') {
        this.addPointsToUser()
      } else {
        this.removePointsFromUser()
      }
      // Sync to WordPress
      this.syncOrderToWordPress()

      // Restore product stock when order is cancelled (only if it wasn't already cancelled)
      if (this.selectedStatus === 'Cancelled' && previousStatus !== 'Cancelled') {
        this.orderService.restoreStock(this.orderData.order).subscribe(() => {
          console.log('Stock restored after order cancellation')
        })
      }

      // Cancel order in Fincart if status is Cancelled and fincartOrderId exists
      if (this.selectedStatus === 'Cancelled' && this.orderData.order.fincartOrderId) {
        this.cancelFincartOrder(this.orderData.order.fincartOrderId)
      }

      console.log('Order status updated successfully', this.selectedStatus)
      this.syncOrderStatusToZoho(this.selectedStatus)
    })
  }

  cancelFincartOrder(fincartOrderId: string) {
    const url = `${this.fincartBaseUrl}/v4/orders/cancel`
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: this.fincartApiKey
    })

    const body = {
      filters: {
        ids: [fincartOrderId]
      }
    }

    this.http.post<any>(url, body, { headers }).subscribe({
      next: (res) => {
        console.log('Fincart order cancelled successfully', res)
      },
      error: (err) => {
        console.error('Failed to cancel Fincart order', err)
      }
    })
  }

  printFincartLabel() {
    const fincartOrderId = this.orderData.order.fincartOrderId?.fincartId
    if (!fincartOrderId) {
      this.toastrService.error('No Fincart order ID found', 'Error')
      return
    }

    const url = `${this.fincartBaseUrl}/v4/orders/awb`
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: this.fincartApiKey
    })

    const body = {
      filters: {
        ids: [fincartOrderId],
        type: 'paper'
      }
    }

    // Make the HTTP POST request expecting a Blob (PDF file)
    this.http.post(url, body, { headers, responseType: 'blob' }).subscribe({
      next: (res: Blob) => {
        // Create a URL for the Blob and open it in a new tab
        const fileURL = URL.createObjectURL(res)
        window.open(fileURL, '_blank')
        this.toastrService.success('Label generated successfully', 'Success')
      },
      error: (err) => {
        console.error('Failed to generate Fincart label', err)
        this.toastrService.error('Failed to generate shipping label', 'Error')
      }
    })
  }

  syncOrderStatusToZoho(newStatus: string) {
    const payload = {
      projectId: this.builderService.selectedProject,
      order_id: this.orderData.order.humId,
      user_id: this.orderData.user_id,
      new_status: newStatus
    }

    console.log('Sending Zoho update payload:', payload)

    this.http.post(environment.builderURL + 'zoho-update-order-status', payload).subscribe({
      next: (res) => console.log('Zoho updated', res),
      error: (err) => console.error('Zoho sync failed', err)
    })
  }

  /*
  The `addPointsToUser` and `removePointsFromUser` functions manage the points data for a user within the database.
  1. **Adding Points to User**:
    - Constructs the database path where the points data will be saved using `selectedProject`, `user_id`, and `order_id` from `orderData`.
    - Checks if `toBeEarned` data exists and is not empty:
      - If `toBeEarned` exists:
        - Maps the `toBeEarned` array to prepare the points data.
        - Fetches existing points data from the database:
          - If existing data is found, it appends the new points to the existing data.
          - If no data exists, it uses only the new points.
        - Calls `setDatabase` with the updated points array.
        - **Success Handling**:
          - Logs a message indicating successful saving of the points data.
        - **Error Handling**:
          - Logs an error message if fetching or saving the points data fails.
      - If `toBeEarned` is undefined or empty:
        - Logs a message indicating that there is no data to move.

  2. **Removing Points from User**:
    - Constructs the database path where the points data will be removed using the `selectedProject`, `user_id`, and `order_id` from `orderData`.
    - Calls `removeDatabaseEndpoint` with the constructed path to remove the points data.
    - **Success Handling**:
      - Logs a message indicating successful removal of points data.
    - **Error Handling**:
      - Logs an error message if removing the points data fails.
*/

  async addPointsToUser() {
    const projectId = this.builderService.selectedProject
    const userId = this.orderData.order?.user_uuid
    const orderId = this.orderData.order_id
    const toBeEarned = this.orderData.order?.toBeEarned
    if (!userId || !toBeEarned) return
    await this.savePointsToUser(projectId, userId, orderId, toBeEarned)
  }

  /**
   * Inserts earn_order ledger rows from toBeEarned and clears the to_be_earned column.
   * The balance trigger on project_user_points_ledger handles total update automatically.
   * @param projectId - The project ID.
   * @param userId - The user UUID from project_users.
   * @param orderId - The Supabase order UUID.
   * @param toBeEarned - Array of pending point entries from project_orders_metadata.to_be_earned.
   */
  private async savePointsToUser(projectId: string, userId: string, orderId: string, toBeEarned: any[]) {
    const now = new Date().toISOString()

    const rows = toBeEarned.map((item: any) => ({
      project_id: Number(projectId),
      user_id: userId,
      order_id: orderId,
      system_id: item.system_id ?? null,
      source_type: 'earn_order',
      points: Math.floor(item.points || 0),
      initial_date: now,
      expiry_date: item.expiry_date ?? null,
      is_expired: false,
    }))

    if (rows.length === 0) return

    await this.pointsService.insertPointsLedgerEntries(rows)
    await this.orderService.deleteOrderMetadata(orderId, 'to_be_earned')

    this.pointsEarned = rows.reduce((sum, r) => sum + r.points, 0)
  }

  /*
  The `removePointsFromUser` function removes points data from the database for a specific user and order.
    1. **Construct Database Path**:
      - Builds the path to the points data using:
        - `selectedProject` from `builderService`
        - `user_id` from `orderData`
        - `order_id` from `orderData`

    2. **Remove Points Data**:
      - Calls `removeDatabaseEndpoint` on `db` with the constructed path to delete the points data.
      - **Success Handling**:
        - Logs a message indicating that points were removed successfully.
      - **Error Handling**:
        - Logs an error message if the removal operation fails.
*/

  async removePointsFromUser() {
    const projectId = this.builderService.selectedProject
    const orderId = this.orderData.order_id

    await this.pointsService.deleteOrderLedgerEntries(orderId, 'earn_order')

    this.pointsEarned = 0
  }

  /**
   * Sets the `editAddress` property to `true`, indicating that the user is in the process of editing addresses.
   */
  editAddresses() {
    this.editAddress = true
  }

  /**
   * Fetches and formats address data from the provided `data` object.
   * This function processes the address data from the `data.user_data.address` object,
   * formatting it into an array of address details. It also identifies the custom address
   * associated with the current order and the selected address based on the `order.address_id`.
   * If no matching address is found, it constructs the address from available order data.
   * @param {any} data - The data object containing the address information.
   * @returns {void}
   */
  fetchAddress(data: any) {
    const formattedAddresses: any[] = []
    const addresses = data.user_data?.address || {}
    let foundSelectedAddress = false

    Object.keys(addresses).forEach((id) => {
      const details = { id: id, ...addresses[id] }
      formattedAddresses.push({ id, ...details })
      if (details.order_id && details.order_id === this.orderIdFromRoute) {
        this.customAddress = details
        this.addressForm.patchValue(this.customAddress)
      } else if (data.order.address_id == id) {
        this.selectedAddress = details
        foundSelectedAddress = true
      }
    })

    // If no matching address found by address_id, construct from available data
    if (!foundSelectedAddress) {
      this.selectedAddress = this.constructAddressFromOrderData(data)
    }
  }

  /**
   * Constructs address object from available order data when the address_id doesn't match
   * any address in user_data.address
   * @param {any} data - The order data object
   * @returns {any} - Constructed address object
   */
  private constructAddressFromOrderData(data: any): any {
    // First, try to get from the address array (most common for app orders)
    if (data.address && Array.isArray(data.address) && data.address.length > 0) {
      return data.address[0]
    }

    // Try to get from user_data.address (get the first/default address)
    if (data.user_data?.address) {
      const addressKeys = Object.keys(data.user_data.address)
      if (addressKeys.length > 0) {
        // Try to find default address first
        for (const key of addressKeys) {
          if (data.user_data.address[key].is_default) {
            return { id: key, ...data.user_data.address[key] }
          }
        }
        // Otherwise return the first address
        const firstKey = addressKeys[0]
        return { id: firstKey, ...data.user_data.address[firstKey] }
      }
    }

    // Fallback: construct from order fields
    const order = data.order || {}
    const userData = data.user_data || {}

    return {
      first_name: userData.given_name || userData.name?.split(' ')[0] || '',
      last_name: userData.family_name || userData.name?.split(' ').slice(1).join(' ') || '',
      billing_address_1: order.street_address || order.address_1 || '',
      billing_country: order.shippingCountry || '',
      billing_state: order.shippingState || '',
      billing_phone: userData.phone || '',
      phone_number: userData.phone || '',
      email: userData.email || ''
    }
  }

  /**
   * Retrieves shipping data from the order service and updates the `shippingCountries` property.
   * @returns {void}
   */
  getShippingData(): void {
    this.orderService.getShipping().subscribe((data) => {
      this.shippingCountries = data
    })
  }

  /**
   * Updates the phone number and billing phone fields in the address form.
   * @param {string} countryCode - The country code for the phone number.
   * @param {any} event - The event object containing the phone number value.
   * @returns {void}
   */
  updatePhoneNumber(countryCode: string, event: any) {
    let phoneNumber = event.target.value
    this.addressForm.controls.phone_number.setValue(phoneNumber)
    if (countryCode && phoneNumber) {
      this.fullPhoneNumber = countryCode + phoneNumber
      this.addressForm.controls.billing_phone.setValue(this.fullPhoneNumber)
      this.addressForm.controls.billing_phone.updateValueAndValidity()
    }
  }

  /**
   * Updates the shipping price based on the selected country.
   * @param {any} selectedCountry - The selected country.
   * @returns {void}
   */
  public updateCountry = (selectedCountry: any) => {
    let countryPrice = 0
    for (const key in this.shippingCountries) {
      if (Object.prototype.hasOwnProperty.call(this.shippingCountries, key)) {
        const element = this.shippingCountries[key]
        if (element.countryName == selectedCountry) {
          countryPrice = Number(element.countryPrice)
          this.possibleGovernates = element.governorates
        }
      }
    }
    if (!this.possibleGovernates) {
      this.shippingPrice = Number(countryPrice)
    } else {
      this.shippingPrice = 0
    }
  }

  /**
   * Updates the shipping price based on the selected state.
   * @param {any} selectedState - The selected state
   * @returns {void}
   */
  public updateState(selectedState: any) {
    for (const key in this.possibleGovernates) {
      if (Object.prototype.hasOwnProperty.call(this.possibleGovernates, key)) {
        const element = this.possibleGovernates[key]
        if (element.governorateName == selectedState) {
          this.shippingPrice = Number(element.governoratePrice)
        }
      }
    }
  }

  /**
   * Adds a custom address to the order.
   * - Patches the address form and adding this values (type, order_id, shipping_price).
   * - Calls the `addAddress` method of the `orderService` to add the address.
   * - Upon successful response, sets `editAddress` to false and calls `getOrderData` to refresh the order data.
   */
  addCustomAddress() {
    this.addressForm.patchValue({
      type: 'customAddress',
      order_id: this.orderData.order_id,
      shipping_price: this.shippingPrice
    })
    this.orderService.addAddress(this.orderData.user_id, this.addressForm.value).subscribe((response: any) => {
      this.editAddress = false
      this.getOrderData(this.orderIdFromRoute)
    })
  }

  /**
   * Updates the address data for the current order.
   * - Calls the `updateAddress` method of the `orderService` to update the address.
   * - Upon successful response, sets `editAddress` to false and calls `getOrderData` to refresh the order data.
   */
  updateAddressData() {
    console.log(this.addressForm.value, this.customAddress)
    this.orderService.updateAddress(this.customAddress.id, this.orderData.user_id, this.addressForm.value).subscribe((response: any) => {
      console.log('Address updated successfully', response)
      this.editAddress = false
      this.getOrderData(this.orderIdFromRoute)
      // Reset the form to avoid showing last added data
    })
  }

  /**
   * Sends the updated order data to the WordPress REST API.
   */
  syncOrderToWordPress() {
    if (!this.orderData) return
    this.integrationsService.getWordpressSiteUrl().subscribe((url) => {
      if (!url) return
      const wpApiUrl = url + '/wp-json/v4/syncUpdateOrder/'
      const payload = {
        order_id: this.orderData.order_id,
        user_id: this.orderData.user_id,
        humId: String(this.orderData.order.humId),
        status: this.orderData.order.status,
        products: this.orderData.order.products,
        address: this.customAddress || this.selectedAddress || {},
        total: this.orderData.order.total || 0,
        shipping_price: this.shippingPrice || 0,
        order_notes: this.addressForm?.value?.order_notes || '',
        currency: this.settingsService.currency,
        wp_order_id: this.orderData.order?.['wp-order-id'] || ''
      }

      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      })

      this.http.post(wpApiUrl, payload, { headers }).subscribe({
        next: (response) => {
          console.log('Order synced to WordPress successfully', response)
        },
        error: (error) => {
          console.error('Failed to sync order to WordPress', error)
        }
      })
    })
  }

  /**
   * Creates a shipment for the current order through the active shipping provider.
   * Delivery details are taken from the order's customer address; provider credentials
   * and origin address are resolved server-side. On success the tracking number and
   * label URL are stored on the order metadata.
   */
  shipNow() {
    if (!this.orderData) {
      this.toastrService.error('Order data not available', 'Error')
      return
    }
    if (this.shipmentLoading) return

    const address = this.customAddress || this.selectedAddress || {}
    const firstName = this.orderData.user_data?.given_name || address.first_name || ''
    const lastName = this.orderData.user_data?.family_name || address.last_name || ''
    const name = `${firstName} ${lastName}`.trim() || this.orderData.order?.guestName || 'Recipient'
    const phone = address.billing_phone || address.phone_number || this.orderData.user_data?.phone || this.orderData.order?.guestPhone || ''
    const city = address.billing_city || address.billing_state || this.orderData.order?.shippingState || ''
    const addressLine = address.billing_address_1 || address.billing_street_Name || this.orderData.order?.street_address || ''
    const countryCode = address.countryIsoCode || address.billing_country || this.orderData.order?.shippingCountry || 'SA'

    const paymentMethod = this.orderData.order?.payment_method?.toLowerCase() || ''
    const isCod = paymentMethod.includes('cash') || paymentMethod === 'cod'

    const payload = {
      projectId: String(this.builderService.selectedProject),
      orderId: String(this.orderData.order_id),
      declaredValue: Number(this.orderData.order?.total) || 0,
      isCod,
      codAmount: isCod ? Number(this.orderData.order?.total) || 0 : 0,
      recipient: {
        name,
        phone: String(phone),
        city,
        address: addressLine,
        countryCode,
        email: address.email || this.orderData.user_data?.email || this.orderData.order?.guestEmail || undefined,
        postalCode: address.billing_postcode || undefined
      }
    }

    this.shipmentLoading = true
    this.orderService.createShipment(payload).subscribe({
      next: (res) => {
        this.shipmentLoading = false
        this.shipmentTrackingNumber = res.trackingNumber || ''
        this.shipmentLabelUrl = res.labelUrl || ''
        this.orderService.setAymakanShipment(this.orderData.order_id, {
          trackingNumber: res.trackingNumber,
          labelUrl: res.labelUrl
        })
        this.toastrService.success('Shipment created successfully', 'Success')
      },
      error: (err) => {
        this.shipmentLoading = false
        const message = err?.error?.message || 'Failed to create shipment'
        this.toastrService.error(message, 'Error')
      }
    })
  }

  /**
   * Opens the shipping label PDF in a new tab.
   */
  openShipmentLabel() {
    if (this.shipmentLabelUrl) {
      window.open(this.shipmentLabelUrl, '_blank')
    }
  }

  shipWithFincart() {
    console.log(this.selectedAddress)
    if (!this.orderData) {
      console.error('Order data not available')
      return
    }

    const address = this.customAddress || this.selectedAddress || {}
    const governorate = address.billing_state || this.orderData.order?.shippingState || ''
    const fincartPrice = getFincartPriceForGovernorate(governorate)

    if (fincartPrice) {

      const dialogData = {
        title: 'Shipping Price Notification',
        governorate,
        price: fincartPrice.toFixed(2)
      };
      const dialogRef = this.dialog.open(WorksDialogComponent, {
        width: '420px',
        data: { name: 'fincartConfirm', finData: dialogData }
      })

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          // proceed with shipping
          this.createFincartOrder(address)
        }
      })
    }
  }

  private createFincartOrder(address: any) {
    const url = `${this.fincartBaseUrl}/v4/orders/create`

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: this.fincartApiKey
    })

    const products = this.orderData.order?.products || []

    const body = {
      instaShip: true,
      source: 's2s',
      orderType: 'delivery',
      customerDetails: this.buildCustomerDetails(address),
      orderDetails: this.buildOrderDetails(products)
    }

    this.http.post<any>(url, body, { headers }).subscribe({
      next: (res) => {
        console.log('Fincart order created successfully', res)
        this.fincartOrder = res
        const fincartOrderId = res.data.orderId
        const fincartOrderCode = res.data.orderCode
        const trackURL = res.data.trackURL
        console.log(this.orderData.order_id)
        if (fincartOrderId) {
          this.orderService.setFincartOrder(fincartOrderId, fincartOrderCode, trackURL, this.orderData.order_id)
          this.getFincartOrderLogs(fincartOrderId)
        }
        this.toastrService.success('Order placed successfully', 'Success')
      },
      error: (err) => {
        console.error('Fincart create order failed', err)
        this.toastrService.error('Failed to place order', 'Error')
      }
    })
  }

  getFincartOrderLogs(orderId: string) {
    const url = `${this.fincartBaseUrl}/v4/orders/${orderId}/logs`
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: this.fincartApiKey
    })

    this.http.get<any>(url, { headers }).subscribe({
      next: (res) => {
        console.log('Fincart order logs:', res)
        const logs = res?.data?.logs || []
        if (logs.length > 0) {
          const latestLog = logs[0]
          const fincartStatus = latestLog.title || ''
          const mappedStatus = this.mapFincartStatusToOrderStatus(fincartStatus)
          if (mappedStatus && mappedStatus !== this.orderData.order.status) {
            this.selectedStatus = mappedStatus
            this.saveUpdateStatus()
          }
        }
      },
      error: (err) => {
        console.error('Failed to get Fincart order logs', err)
      }
    })
  }

  private mapFincartStatusToOrderStatus(fincartStatus: string): string {
    const statusMap: { [key: string]: string } = {
      Pending: 'Pending',
      Processing: 'Processing',
      Successful: 'Completed',
      Unsuccessful: 'On hold',
      Cancelled: 'Cancelled',
      'Out for Delivery': 'Processing',
      Delivered: 'Completed',
      Returned: 'Refunded'
    }
    return statusMap[fincartStatus] || ''
  }

  private buildCustomerDetails(address: any): any {
    console.log(this.orderData.user_data)
    const firstName = this.orderData.user_data?.given_name || address.first_name || ''
    const lastName = this.orderData.user_data?.family_name || address.last_name || ''
    const phone = address.billing_phone || address.phone_number || this.orderData.address[0].phone_number

    const rawCity = address.billing_state || this.orderData.order?.shippingState || ''
    const rawArea = address.area || this.orderData.order?.shippingState || ''

    const fincartCity = this.shippingService.findFincartCity(rawCity) || rawCity
    const fincartArea = this.shippingService.findFincartArea(fincartCity, rawArea) || rawArea

    return {
      name: `${firstName} ${lastName}`.trim(),
      phone: phone,
      address: {
        addressLine: address.billing_address_1 || address.billing_street_Name || this.orderData.order.street_address,
        city: fincartCity,
        area: address.billing_street_Name,
        landmark: ''
      },
      shippingNotes: this.orderData.order?.order_notes || address.order_notes || '',
      backupPhone: address.billing_phone || address.phone_number || this.orderData.address[0].phone_number
    }
  }

  isPhoneNumber(value: string): boolean {
    if (!value) return false
    return /^\+?[\d\s\-().]{7,}$/.test(value.trim())
  }

  openFincartOrder(fincartOrderId: any) {
    console.log(fincartOrderId)
    window.open(`https://api.dev.fincart.io/orders?orderType=domestic&orderId=${fincartOrderId}`, '_blank')
  }
  openFincartTracking(fincartTrackingUrl: any) {
    console.log(fincartTrackingUrl)
    window.open(`${fincartTrackingUrl}`, '_blank')
  }

  private buildOrderDetails(products: any[]): any {
    const totalItems = products.reduce((sum: number, p: any) => sum + (p.quantity || 1), 0)
    const description = products.map((p: any) => `${p.quantity || 1} X ${p.productName || p.name || 'Item'}`).join(', ')
    const paymentMethod = this.orderData.order?.payment_method?.toLowerCase() || ''
    const isCashPayment = paymentMethod.includes('cash') || paymentMethod === 'cod'

    return {
      paymentType: isCashPayment ? 'with_cash_collection' : 'without_cash_collection',
      pickupLocationId: this.fincartPickupLocationId,
      packageType: 'parcel',
      amount: this.orderData.order?.total || 0,
      noOfItems: totalItems || 1,
      description: description || 'Order items',
      openPackageAllowed: true,
      referenceNumber: `#${this.orderData.order?.humId || this.orderIdFromRoute}`,
      serviceType: 'standard'
    }
  }




}
